
import {  Main } from './components';
import './App.scss';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const WebPage = () => {
  return (
    <div className="App">
       <Main />
    </div>
  )
}

export default WebPage;